import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  propertiesController: [
    'runtimeConstant',
    '$scope',
    'authService',
    '$rootScope',
    'revisionService',
    'digitalizationService',
    '$filter',
    '$uibModalInstance',
    '$uibModal',
    'EDocumentStatus',
    'idRevision',
    'isDigitalization',
    'flowExecutionService',
    'treeService',
    'taskModel',
    'additionalFieldService',
    'validationService',
    'EFeatures',
    'EAdminFeatures',
    'insideFlow',
    'guid',
    '$state',
    '$window',
    'webApiSettings',
    '$timeout',
    function (
      runtimeConstant,
      $scope,
      authService,
      $rootScope,
      revisionService,
      digitalizationService,
      $filter,
      $uibModalInstance,
      uibModal,
      EDocumentStatus,
      idRevision,
      isDigitalization,
      flowExecutionService,
      treeService,
      Task,
      AdditionalField,
      validationService,
      EFeatures,
      EAdminFeatures,
      insideFlow,
      guid,
      $state,
      window,
      webApiSettings,
      $timeout
    ) {
      'use strict';

      function loadRevision() {
        $scope.isCompanyAdmin = authService.isAdmin();
        $scope.loadingRevision = true;
        $scope.revision = null;

        const loadRevisionInternal = function (data) {
          $scope.revision = data;

          if ($scope.revision !== null) {
            var addFields = [];
            if ($scope.revision.revisionAdditionalFields) {
              for (
                let cont = 0;
                cont < $scope.revision.revisionAdditionalFields.length;
                cont++
              ) {
                var af = $scope.revision.revisionAdditionalFields[cont];
                var addF = new AdditionalField(af);

                addFields.push(addF);
              }
              $scope.revision.revisionAdditionalFields = addFields;
            }

            $scope.setKeywords($scope.revision.keywords);

            if ($scope.revision.documentType && $scope.revision.documentType.Id) {
              $scope.loadDocTypeAddFields();
            }

            if ($scope.revision.idFolder && $scope.revision.idFolder > 0) {
              $scope.loadDocumentTypes();
            } else {
              $scope.documentTypes = [];
              $scope.documentTypesIds = [];
              $scope.loadingDocTypes = false;
            }

            $scope.setPath();
            if ($scope.revision.hasWorkflow) $scope.loadWorkflowExecutions();

            if ($rootScope.user.isSysAdmin === true) {
              $scope.idFeature = true;
            } else {
              $rootScope.user.adminFeatures.forEach((data) => {
                if (data.IdAdminFeature === EAdminFeatures.ManageExpire) {
                  $scope.idFeature = true;
                }
              });
            }
          }

          $scope.loadingRevision = false;
        };

        if ($scope.isDigitalization) {
          digitalizationService
            .findDigitalization($scope.idRevision)
            .then((data) => {
              loadRevisionInternal(data);
            })
            .catch((err) => {
              swal.fire({ title: err.title, text: err.text });
              $scope.loadingRevision = false;
            });
        } else {
          revisionService
            .findRevision($scope.idRevision, $scope.isFlow)
            .then((data) => {
              loadRevisionInternal(data);
            })
            .catch((err) => {
              swal.fire({ title: err.title, text: err.text });
              $scope.loadingRevision = false;
            });
        }
      }

      function setKeywords(value) {
        if (value) {
          $scope.revision.keywords = value.includes(';')
            ? value.split(';')
            : [value];
        }
      }

      function pickFolder() {
        var modal = uibModal.open({
          animation: true,
          templateUrl: '/views/partials/pickFolder.html',
          controller: 'pickFolderController',
          backdrop: 'static',
          keyboard: true,
          size: 'sm',
          resolve: {
            treeSendFiles: function () { return true; },
            canSelectRepository: function () { return false; },
            idFolderNotShow: function () { return undefined; },
          },
        });

        modal.result.then(function (folder) {
          if ($scope.revision.idFolder !== folder.Id) {
            $scope.revision.folder = folder;
            $scope.revision.idFolder = folder.Id;

            $scope.revision.documentType = null;
            $scope.revision.idDocumentType = null;
            $scope.documentTypes = [];
            $scope.documentTypesIds = [];

            $scope.loadDocumentTypes();
          }
        });
      }

      function loadDocTypeAddFields() {
        $scope.loadingAddFields = true;
        treeService
          .getDocumentTypeAdditionalFields($scope.revision.documentType.Id)
          .then((data) => {
            $scope.createAddFields(data);
            $scope.loadingAddFields = false;
          })
          .catch(() => {
            $scope.loadingAddFields = false;
          });
      }

      function loadDocumentTypes() {
        $scope.loadingDocTypes = true;

        if (!$scope.revision || !$scope.revision.idFolder || $scope.revision.idFolder <= 0) {
          $scope.documentTypes = [];
          $scope.documentTypesIds = [];
          $scope.loadingDocTypes = false;
          return;
        }

        treeService
          .getFolderDocumentTypes($scope.revision.idFolder)
          .then(function (data) {
            $scope.documentTypes = data || [];
            $scope.documentTypesIds = $scope.documentTypes.map(function (d) {
              return d.Id;
            });

            if (
              $scope.revision.documentType &&
              $scope.documentTypesIds.indexOf($scope.revision.documentType.Id) < 0
            ) {
              $scope.revision.documentType = null;
              $scope.revision.idDocumentType = null;
            }

            $scope.loadingDocTypes = false;
          })
          .catch(function () {
            $scope.documentTypes = [];
            $scope.documentTypesIds = [];
            $scope.loadingDocTypes = false;
          });
      }

      function selectOldRevision(oldRev) {
        $scope.selectedOldRevision = oldRev;
      }

      function viewDoc() {
        var url = '';
        var revision = $scope.selectedOldRevision;
        var dataUri = {
          revision: {
            id: revision.id,
            idCompany: revision.idCompany,
            isHistory: true,
            extension: revision.extension.toLowerCase(),
            title: revision.title,
            server: webApiSettings.viewerServer,
            rowGuid: revision.guid,
            pageCount: revision.numberOfPages,
            userId: authService.user.id,
          },
          token: authService.authentication.token,
          webApiUrl: webApiSettings.apiServiceBaseUri,
          detailsCompany: webApiSettings.detailsCompany,
          infos: {
            canPrint: revision.canDownload,
            canDownload: revision.canDownload,
            urlBase: window.location.href,
          },
          signers: [],
        };

        if ($scope.selectedOldRevision.idRevisionHistory !== undefined) {
          dataUri.revision.isOldRevision = true;
          dataUri.revision.id = docs[i].idRevisionHistory;
        }
        var encoded = encodeURIComponent(JSON.stringify(dataUri));

        url = webApiSettings.viewerBaseUri + '#/' + encoded;

        $scope.openView(url);
      }

      function openView(url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }

      function loadOldRevisions() {
        if ($scope.oldRevisions === null) {
          $scope.oldRevisions = [];
          $scope.loadingOldRevisions = true;
          revisionService
            .loadOldRevisions($scope.revision.id)
            .then((data) => {
              $scope.oldRevisions = data;
              $scope.loadingOldRevisions = false;
            })
            .catch(() => {
              $scope.loadingOldRevisions = false;
            });
        }
      }

      function createAddFields(addFields) {
        for (
          var i = 0;
          i < $scope.revision.revisionAdditionalFields.length;
          i++
        ) {
          var af = $scope.revision.revisionAdditionalFields[i];
          var value = af.value;
          switch (af.fieldType) {
            case 1:
              value =
                af.value &&
                ((typeof af.value === 'string' &&
                  af.value.toLowerCase() === 'true') ||
                  af.value === true);
              break;
            case 2:
              value = af.value ? Number.parseInt(af.value) : null;
              break;
            case 4:
              value = af.value ? Number.parseFloat(af.value) : null;
              break;
            case 6:
              if (af.value && typeof af.value === 'string') {
                var s = af.value.split('/');
                if (s.length === 3)
                  value = new Date(s[2], Number(s[1]) - 1, s[0]);
              }
              break;
            default:
              break;
          }
          var a = addFields.filter((a) => a.id === af.id)[0];
          if (a) a.value = value;
        }
        $scope.revision.revisionAdditionalFields = addFields;
      }

      function additionalField(value) {
        if (this.field) {
          var id = this.field.id;
          var type = this.field.fieldType;
        }

        if (arguments.length > 0) {
          if (type === 1 && value === undefined) value = false;

          var fields = $scope.revision.revisionAdditionalFields.filter(
            (f) => f.id === id
          );

          fields.forEach((f) => {
            f.value = value;
          });
        } else {
          return $scope.revision.revisionAdditionalFields.filter(
            (f) => f.id === id
          )[0].value;
        }
      }

      function isValid(value) {
        // CPF
        if (this.field.validationType === 1) {
          $scope.isCheckCpfOrCpnj = validationService.validateCPF(value);
          return $scope.isCheckCpfOrCpnj;
        }

        // CNPJ
        if (this.field.validationType === 2) {
          $scope.isCheckCpfOrCpnj = validationService.validateCNPJ(value);
          return $scope.isCheckCpfOrCpnj;
        }

        return true;
      }

      function canEditProperties() {
        if ($scope.revision) {
          var hasPermission = $scope.revision.checkPermission(
            EFeatures.CHANGE_PROPERTIES
          );
          var notEditStatus = [
            EDocumentStatus.OBSOLETE,
            EDocumentStatus.IN_FLOW,
            EDocumentStatus.IN_CHECKOUT,
          ];
          return (
            (hasPermission &&
              notEditStatus.indexOf($scope.revision.idStatus) < 0) ||
            insideFlow
          );
        } else {
          return false;
        }
      }

      function canEditFolder() {
        if ($scope.revision) {
          var hasPermission = $scope.revision.checkPermission(
            EFeatures.CHANGE_PROPERTIES
          );
          var notEditStatus = [
            EDocumentStatus.IN_FLOW,
            EDocumentStatus.IN_CHECKOUT,
          ];
          return (
            hasPermission && notEditStatus.indexOf($scope.revision.idStatus) < 0
          );
        } else {
          return false;
        }
      }

      function canReplaceFile() {
        if ($scope.revision) {
          return $scope.revision.checkPermission(EFeatures.REPLACE_FILE);
        } else {
          return false;
        }
      }

      function canDownloadOldRevision() {
        if ($scope.revision) {
          return $scope.revision.checkPermission(
            EFeatures.DOWNLOAD_OLD_REVISIONS
          );
        } else {
          return false;
        }
      }

      function canViewOldRevision() {
        if ($scope.revision) {
          return $scope.revision.checkPermission(EFeatures.VIEW_OLD_REVISIONS);
        } else {
          return false;
        }
      }

      function setPath() {
        if ($scope.revision.idFolder > 0) {
          flowExecutionService.getPath($scope.revision.idFolder).then((data) => {
            $scope.path = data;
          });
        }
      }

      function loadWorkflowExecutions() {
        if ($scope.executions !== null && $scope.executions.length > 0) return;

        flowExecutionService
          .listRevisionExecutions($scope.idRevision)
          .then((data) => {
            $scope.executions = data;
          });
      }

      function generateReport(execution) {
        swal.fire({
          title: $filter('translate')('WAIT GENERATING REPORT'),
          icon: 'info',
          showConfirmButton: false,
          showCancelButton: false,
        });
        flowExecutionService
          .generateReport(execution.LastStep)
          .then((res) => {
            var url = URL.createObjectURL(res.data);
            window.open(url);
            swal.close();
          })
          .catch((error) => {
            swal.fire({
              title: error.title,
              text: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });
      }

      function hideExecutionDetail() {
        $scope.showWorkflowDetail = false;
        $scope.currentExecution.showDetails = true;
        $scope.currentExecution = null;
        $scope.gps = null;
        $scope.histories = null;
      }

      function toggleExecutionDetail(execution) {
        if ($scope.showWorkflowDetail === true) {
          $scope.showWorkflowDetail = false;
          $scope.currentExecution = null;
          $scope.currentStep = null;
          execution.showDetails = false;
          $scope.histories = [];
          return;
        }

        $scope.showWorkflowDetail = true;
        $scope.currentExecution = execution;
        execution.showDetails = true;

        if (execution.history === undefined || execution.history === null) {
          flowExecutionService
            .loadHistories(execution.LastStep)
            .then((data) => {
              $scope.histories = [];

              data.forEach((item) => {
                var step = $scope.histories.filter(
                  (h) => h.id === item.idExecutionStep
                )[0];

                if (step === undefined) {
                  step = {
                    id: item.idExecutionStep,
                    step: new Task(item.step),
                    icon: item.icon(),
                    actions: [],
                  };

                  $scope.histories.push(step);
                }

                var userAction = {
                  id: item.id,
                  action: item.action,
                  form: item.form,
                  comments: item.comments,
                  date: item.date,
                  user: item.user,
                  icon: item.icon(),
                  title: item.title(),
                };

                step.actions.push(userAction);
              });

              $scope.currentStep = $scope.histories[0];
            });
        }
      }

      function getExecutionStatus(execution) {
        switch (execution.Status) {
          case 0:
            return 'Novo';
          case 1:
            return 'Iniciado';
          case 2:
            return 'Aprovado';
          case 3:
            return 'Não aprovado';
          case 4:
            return 'Cancelado';
        }
      }

      function getSelectedDecisionOption(index) {
        var task = $scope.gps[index];
        var next = $scope.gps[index + 1];

        if (!task || !next) return null;
        return task.element.Links.filter(
          (l) => l.IdNextElement === next.idElement
        )[0];
      }

      function getSelectedDecisionColor(index) {
        var link = $scope.getSelectedDecisionOption(index);

        return link !== null && link.CssColor !== undefined
          ? link.CssColor
          : 'blank';
      }

      function selectStep(step) {
        $scope.currentStep = step;
      }

      function canSave() {
        return (
          $scope.revision.canSaveAddFields() === true &&
          !$scope.loadingAddFields &&
          !$scope.loadingDocTypes &&
          !$scope.loadingRevision &&
          $scope.isCheckCpfOrCpnj
        );
      }

      function save() {
        swal.fire({
          title: $filter('translate')('WAIT SAVING'),
          text: $filter('translate')('WAIT SAVING MSG'),
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          icon: 'info',
        });

        $scope.revision
          .updateProperties()
          .then((data) => {
            swal.close();

            if ($scope.isDigitalization) {
              $uibModalInstance.close(true);

              var classificationName =
                (data && (data.classificationName || data.ClassificationName)) ||
                (($scope.revision.description || '').startsWith('CLASSIFICATION_PENDING:')
                  ? $scope.revision.description.replace('CLASSIFICATION_PENDING:', '')
                  : '—');

              var folderName =
                (data && (data.folderName || data.FolderName)) ||
                ($scope.revision.folder && $scope.revision.folder.Name) ||
                '—';

              var documentTypeName =
                (data && (data.documentTypeName || data.DocumentTypeName)) ||
                ($scope.revision.documentType && $scope.revision.documentType.Name) ||
                '—';

              var documentTitle =
                ($scope.revision && $scope.revision.title) || '—';

              var idFolder =
                (data && (data.idFolder || data.IdFolder)) ||
                ($scope.revision.folder && $scope.revision.folder.Id) ||
                null;

              var reprocessedCount =
                (data && (data.reprocessedCount || data.ReprocessedCount)) || 0;

              var html =
                '<p class="dd-classif-subtitle">O documento foi registrado com sucesso no acervo.</p>' +
                '<div class="dd-classif-box">' +

                '<div class="dd-classif-row">' +
                '<span class="dd-classif-label"><i class="fa fa-file-text-o"></i> Documento</span>' +
                '<span class="dd-classif-value">' + documentTitle + '</span>' +
                '</div>' +

                '<div class="dd-classif-row">' +
                '<span class="dd-classif-label"><i class="fa fa-tag"></i> Classificação</span>' +
                '<span class="dd-classif-value">' + classificationName + '</span>' +
                '</div>' +

                '<div class="dd-classif-row">' +
                '<span class="dd-classif-label"><i class="fa fa-folder-open-o"></i> Pasta</span>' +
                '<span class="dd-classif-value">' + folderName + '</span>' +
                '</div>' +

                '<div class="dd-classif-row">' +
                '<span class="dd-classif-label"><i class="fa fa-files-o"></i> Tipo</span>' +
                '<span class="dd-classif-value">' + documentTypeName + '</span>' +
                '</div>';

              if (reprocessedCount > 0) {
                html +=
                  '<div class="dd-classif-divider"></div>' +
                  '<div class="dd-classif-hint">' +
                  '<i class="fa fa-info-circle"></i>' +
                  '<span><strong>' + reprocessedCount + '</strong> documento(s) com a mesma classificação ' +
                  'foram colocados na fila e serão processados automaticamente em breve.</span>' +
                  '</div>';
              }

              html += '</div>';

              swal
                .fire({
                  title: 'Classificação concluída',
                  html: html,
                  icon: 'success',
                  showCancelButton: !!idFolder,
                  confirmButtonText: idFolder
                    ? '<i class="fa fa-folder-open"></i> Abrir pasta'
                    : ($filter('translate')('OK') || 'OK'),
                  cancelButtonText: $filter('translate')('CLOSE') || 'Fechar',
                  confirmButtonColor: '#5cb85c',
                  cancelButtonColor: '#9e9e9e',
                  reverseButtons: true,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  width: '28em',
                  customClass: {
                    popup: 'swal-classificacao-concluida',
                  },
                })
                .then(function (result) {
                  if (result.isConfirmed && idFolder) {
                    var folderId = Number(idFolder);

                    if (!folderId || folderId <= 0) {
                      return;
                    }

                    $timeout(function () {
                      $state.go('home.folder', { id: folderId, page: 1 });
                      $rootScope.$broadcast('loadFolder', folderId);
                    }, 0);
                  }

                  $rootScope.$broadcast('RELOAD_DIGITALIZATIONS');
                  $rootScope.$broadcast('RESUME_AUTO_REFRESH');
                });

              return;
            }

            // Outras telas (revisão normal)
            $rootScope.$broadcast('updateRevision', data);
            $uibModalInstance.close(true);

            if (insideFlow) {
              flowExecutionService
                .saveHistory(guid, 'properties')
                .then(function () {
                  $rootScope.$broadcast('save_flowRevisionHistory');
                });
            }

            $state.reload();
          })
          .catch(function (error) {
            swal.close();

            if ($scope.isDigitalization) {
              swal.fire({
                title:
                  (error && (error.error || error.Error)) || 'Erro',
                text:
                  (error &&
                    (error.errorDescription || error.ErrorDescription)) ||
                  '',
                showConfirmButton: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                icon: 'error',
              });
            }
          });
      }

      function cancel() {
        $scope.messageTitle = $filter('translate')('CONFIRM CANCEL');
        $scope.messageCancel = $filter('translate')('NO');
        $scope.messageForward = $filter('translate')('YES');
        $scope.modalQuestion = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/questionModal/questionModal.html',
          controller: 'questionModalController',
          size: 'small',
          windowClass: 'modal-remove',
        });
      }

      function enableExpireDateField() {
        document.getElementById('checkedit').disabled = false;
      }

      function revisionDateExpire() {
        if (!$scope.revision.isExpired()) {
          document.getElementById('revisiondate').disabled = false;
        } else {
          document.getElementById('revisiondate').disabled = true;
        }
      }

      function toggleOcr() {
        $scope.ocrExpanded = !$scope.ocrExpanded;

        if (
          !$scope.ocrExpanded ||
          $scope.loadingOcr ||
          $scope.ocrLoaded
        ) {
          return;
        }

        $scope.loadingOcr = true;

        revisionService
          .getOcr($scope.revision.id)
          .then((data) => {
            var response = data.Data || data.data || data;

            var content = response.Content || response.content || '';
            var status = (response.Status || response.status || '').toLowerCase();

            if (!status) {
              status = content ? 'available' : 'processing';
            }

            $scope.ocr = {
              status: status,
              content: content,
            };

            $scope.ocrLoaded = true;
          })
          .catch(() => {
            $scope.ocr = {
              status: 'error',
              content: null,
            };
            $scope.ocrLoaded = true;
          })
          .finally(() => {
            $scope.loadingOcr = false;
          });
      }

      function run() {
        try {
          $scope.isFlow = insideFlow ? true : false;
          $scope.idRevision = idRevision;
          $scope.isDigitalization = isDigitalization === true;
          $scope.executions = null;
          $scope.documentTypes = [];
          $scope.oldRevisions = null;
          $scope.selectedOldRevision = null;
          $scope.path = null;
          $scope.idFeature = false;
          $scope.isCheckCpfOrCpnj = true;
          $scope.showAllHistories = false;

          $scope.ocrExpanded = false;
          $scope.ocrLoaded = false;
          $scope.loadingOcr = false;
          $scope.ocr = null;

          $scope.loadRevision = logWrapper(
            loadRevision,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setKeywords = logWrapper(
            setKeywords,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.pickFolder = logWrapper(
            pickFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocTypeAddFields = logWrapper(
            loadDocTypeAddFields,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocumentTypes = logWrapper(
            loadDocumentTypes,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectOldRevision = logWrapper(
            selectOldRevision,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.viewDoc = logWrapper(
            viewDoc,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.openView = logWrapper(
            openView,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadOldRevisions = logWrapper(
            loadOldRevisions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.createAddFields = logWrapper(
            createAddFields,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.additionalField = logWrapper(
            additionalField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isValid = logWrapper(
            isValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canEditProperties = logWrapper(
            canEditProperties,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canEditFolder = logWrapper(
            canEditFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canReplaceFile = logWrapper(
            canReplaceFile,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canDownloadOldRevision = logWrapper(
            canDownloadOldRevision,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canViewOldRevision = logWrapper(
            canViewOldRevision,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setPath = logWrapper(
            setPath,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadWorkflowExecutions = logWrapper(
            loadWorkflowExecutions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.generateReport = logWrapper(
            generateReport,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hideExecutionDetail = logWrapper(
            hideExecutionDetail,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleExecutionDetail = logWrapper(
            toggleExecutionDetail,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getExecutionStatus = logWrapper(
            getExecutionStatus,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSelectedDecisionOption = logWrapper(
            getSelectedDecisionOption,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSelectedDecisionColor = logWrapper(
            getSelectedDecisionColor,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectStep = logWrapper(
            selectStep,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSave = logWrapper(
            canSave,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.enableExpireDateField = logWrapper(
            enableExpireDateField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.revisionDateExpire = logWrapper(
            revisionDateExpire,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleOcr = logWrapper(
            toggleOcr,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
